import { APExpanded, APRow } from "../layout"
import { APChartColors, APPalette } from "../utils"

export function JourneyProgressBar(props: { totalSteps: number, currentStep: number }) {
    return <APRow mainAxisSize="max">
        <APExpanded flex={props.currentStep + 1}><div style={{ height: "2px", backgroundColor: APChartColors["blue-500"] }}></div></APExpanded>
        <APExpanded flex={props.totalSteps - props.currentStep - 1}><div style={{ height: "2px", backgroundColor: APPalette["grey-300"] }}></div></APExpanded>
    </APRow>
}